import { render, staticRenderFns } from "./SystemConfigPage.vue?vue&type=template&id=0f4c2c35&scoped=true&"
import script from "./SystemConfigPage.vue?vue&type=script&lang=js&"
export * from "./SystemConfigPage.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigPage.vue?vue&type=style&index=0&id=0f4c2c35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c2c35",
  null
  
)

export default component.exports